import { config } from '@lingoda/config';

type HandledDixaCommands = 'setWidgetOpen';
type HandledWidgetEvents = 'on-widget-open-changed';

type Invoke = (command: HandledDixaCommands, ...args: (string | boolean | object)[]) => void;
type Dixa = {
    // Commands docs: https://docs.dixa.io/docs/dixamessenger/web/commands/
    invoke?: Invoke;
    // Widget events docs: https://docs.dixa.io/docs/dixamessenger/web/events/
    /* eslint-disable @typescript-eslint/no-explicit-any */
    addListener?: (event: HandledWidgetEvents, listener: (...args: any[]) => void) => void;
    removeListener?: (event: HandledWidgetEvents, listener: (...args: any[]) => void) => void;
    /* eslint-enable @typescript-eslint/no-explicit-any */
};

interface WindowWithDixa extends Window {
    _dixa_?: Dixa;
}

declare const window: WindowWithDixa;

const getIsDixaInitialized = () => {
    return !!window._dixa_;
};

export const DixaMessenger = {
    /** Dixa initialization script injection on non-prod environment. On prod it's controlled by GTM. */
    initializeNonProdScript: () => {
        return config.deployEnvironment === 'production'
            ? []
            : [{ type: 'text/javascript', innerHTML: dixaDevEnvInitScript }];
    },
    getIsDixaInitialized,
    setWidgetOpen: (open: boolean) => {
        if (!getIsDixaInitialized()) {
            console.error('Dixa help center is not initialized yet');

            return;
        }

        window._dixa_?.invoke?.('setWidgetOpen', open);
    },
    widgetOpenListener: (listener: (isOpen: boolean) => void) => {
        window._dixa_?.addListener?.('on-widget-open-changed', listener);

        return () => {
            window._dixa_?.removeListener?.('on-widget-open-changed', listener);
        };
    },
};

/**
 *  Script from lingoda.dixa.com panel Setup -> Messenger -> Student - Int -> Setup
 *
 *  https://lingoda.dixa.com/settings/dixa-messenger/appearance/9d482824-001b-4bbb-902f-a31a00e807f5
 *
 *  It requires invitation to lingoda.dixa.com company.
 */
const dixaDevEnvInitScript = `
(function (w, d, s) {
  if (w._dixa_) return;
  w._dixa_ = {
    invoke: function (m, a) {
      w._dixa_.pendingCalls = w._dixa_.pendingCalls || [];
      w._dixa_.pendingCalls.push([m, a]);
    },
    addListener: function (event, listener) {
      w._dixa_.pendingAddListenerCalls = w._dixa_.pendingAddListenerCalls || [];
      w._dixa_.pendingAddListenerCalls.push([event, listener]);
    },
  };
  s = d.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('charset', 'utf-8');
  s.async = true;
  s.src = 'https://messenger.dixa.io/bootstrap.js';
  var before = d.getElementsByTagName('script')[0];
  before.parentNode.insertBefore(s, before);
})(window, document);
_dixa_.invoke('init', { messengerToken: '0ace3757bd3b4ba6b4222c2ef7bec8a4' });
console.log('INFO: DIXA LOADED TO DOM');
`;
